export enum ESpecialRegistrationAction {
	EDIT = 'Edit',
	TERMINATE = 'Schedule service termination',
	CANCEL_TERMINATION = 'Cancel schedule termination',
}
